import { IconLibrary } from '@product-framework/index';
import { Box, Button, Pagination } from '@mui/material';
import { forwardRef, useEffect, useState } from 'react';
import {
  SnackbarApiErrorMessage,
  useDataProvider,
  useSnackbar,
} from '@ui-framework/index';

const IndustriesServiced = forwardRef(
  ({ onChange = () => undefined, dependentOnValues = null }, ref) => {
    const nameKey = 'industryName';
    const valueKey = 'id';
    const snackbar = useSnackbar();
    const provider =
      process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
    const { get, getApiUrl } = useDataProvider(provider);
    const [industriesServiced, setIndustriesServiced] = useState([]);
    const [selected, setSelected] = useState();
    const limit = 10;

    const getPageCount = (total, limitArg) => Math.ceil(total / limitArg);

    const getIndustriesServiced = async () => {
      if (
        Array.isArray(dependentOnValues) &&
        dependentOnValues[0]?.label !== 'All'
      ) {
        return {
          data: [...dependentOnValues],
          total: dependentOnValues.length,
        };
      }
      const response = await get(`${getApiUrl()}/sxcl/v1/industries`);
      if (response.ok) {
        const { data = [], ...other } = response.data;
        const resultsData =
          data?.map(item => ({
            label: item[nameKey],
            value: item[valueKey],
          })) || [];
        return { data: resultsData, ...other };
      }
      snackbar.showMessage({
        type: 'error',
        data: <SnackbarApiErrorMessage errors={response?.errors} />,
      });
      return [];
    };

    const initialize = async () => {
      const { data } = await getIndustriesServiced();
      setIndustriesServiced(data || {});
      const selectedIndustry = data?.length > 0 ? data[0].value : undefined;
      setSelected(selectedIndustry);
      onChange(data?.length > 0 ? data[0] : { label: '', value: '' });
    };

    useEffect(() => {
      initialize();
    }, []);

    const pageCount = getPageCount(industriesServiced?.total, limit);

    return (
      <Box ref={ref}>
        <Box
          border={1}
          borderColor="divider"
          borderRadius={1}
          sx={{
            padding: 1,
            height: '448px',
            marginBottom: 2,
            marginTop: 2,
            scrollbarWidth: 'thin',
            overflow: 'scroll',
          }}>
          {industriesServiced?.map(industry => (
            <Button
              onClick={() => {
                setSelected(industry.value);
                onChange(industry);
              }}
              {...(selected === industry.value && {
                endIcon: <IconLibrary.Next />,
              })}
              fullWidth
              color={selected === industry.value ? 'primary' : 'secondary'}
              variant="contained"
              key={industry.label}
              sx={{ minHeight: '40px', marginBottom: '5px' }}>
              {industry.label}
            </Button>
          ))}
        </Box>
        {pageCount > 1 && (
          <Pagination
            onChange={async (event, value) => {
              const newItems = await getIndustriesServiced(value);
              setIndustriesServiced(newItems);
            }}
            sx={{
              mt: 1,
              mr: 1,
              ml: 1,
              justifyContent: 'flex-end',
              display: 'flex',
            }}
            count={pageCount}
            size="small"
          />
        )}
      </Box>
    );
  },
);

export default IndustriesServiced;
